import React from 'react';
import { CreditCardIcon, CheckCircleIcon, DownloadIcon } from 'lucide-react';
export function HowToReceiveSection() {
  const steps = [{
    icon: <CreditCardIcon className="w-10 h-10 text-[#16a34a]" data-id="element-90" />,
    title: 'Paso 1',
    desc: 'Realizás la compra e ingresás tu correo.'
  }, {
    icon: <CheckCircleIcon className="w-10 h-10 text-[#16a34a]" data-id="element-91" />,
    title: 'Paso 2',
    desc: 'Finalizás el pago.'
  }, {
    icon: <DownloadIcon className="w-10 h-10 text-[#16a34a]" data-id="element-92" />,
    title: 'Paso 3',
    desc: 'Recibís automáticamente el link de descarga.'
  }];
  return <section className="w-full bg-white py-10 px-4 md:px-8 text-center" data-id="element-93">
      <div className="max-w-4xl mx-auto" data-id="element-94">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-95">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-96">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center" data-id="element-97">
              <div className="bg-green-50 p-3 rounded-full mb-3" data-id="element-98">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-99">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-100">{step.desc}</p>
            </div>)}
        </div>

        <p className="mt-6 text-xl font-bold text-[#16a34a]" data-id="element-101">
          Acceso inmediato.
        </p>
      </div>
    </section>;
}